export enum AuthTypes {
  LOGIN_DISTRIBUTOR_REQUEST = 'LOGIN_DISTRIBUTOR_REQUEST',
  LOGIN_DISTRIBUTOR_SUCCESS = 'LOGIN_DISTRIBUTOR_SUCCESS',
  LOGIN_DISTRIBUTOR_FAILURE = 'LOGIN_DISTRIBUTOR_FAILURE',
  PERSIST_REHYDRATE = 'persist/REHYDRATE',
}

/**
 * State type
 * @data : the constructionCompany
 */
export interface AuthStateDistributor {
  token: string;
  isLoggedIn: boolean;
}
